import React, { useState } from 'react'
import Highcharts from 'highcharts'
import { getApprovalsPending } from 'src/services/api/charts'
import { Chart } from '../components/chart'
import { Props } from './types'
import { utilData } from '../components/util-data'

const chartData = {
  chart: {
    type: 'solidgauge'
  },
  title: {
    text: 'Aprovações pendentes'
  },
  pane: {
    center: ['50%', '85%'],
    size: '140%',
    startAngle: -90,
    endAngle: 90,
    background: {
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || '#fafafa',
      borderRadius: 5,
      innerRadius: '60%',
      outerRadius: '100%',
      shape: 'arc'
    }
  },
  exporting: {
    enabled: true
  },
  tooltip: {
    enabled: false
  },
  yAxis: {
    min: 0,
    max: 10,
    stops: [
      [0.1, '#55BF3B'],
      [0.3, '#FFFF00'],
      [0.5, '#ffa500'],
      [0.8, '#DF5353']
    ],
    lineWidth: 0,
    tickWidth: 0,
    minorTickInterval: null as any,
    tickAmount: 2,
    title: {
      y: -70
    },
    labels: {
      y: 16
    }
  },
  series: [
    {
      name: '',
      data: [0],
      dataLabels: {
        format:
          '<div style="text-align:center"><span style="font-size:50px;">{y}</span><br/></div>'
      }
    }
  ],
  plotOptions: {
    solidgauge: {
      borderRadius: 30,
      dataLabels: {
        y: 5,
        borderWidth: 0,
        useHTML: true
      }
    }
  }
}

function updateChatData(label: string, value: number) {
  return {
    ...chartData,
    series: [
      {
        name: label,
        data: [value],
        dataLabels: {
          format:
            '<div style="text-align:center"><span style="font-size:50px;">{y}</span><br/></div>'
        }
      }
    ]
  }
}

export default function ApprovalsPending({ organization_id }: Props) {
  const [isLoading, setIsLoading] = useState(false)

  async function updateChart(monthFilter: string) {
    if (!monthFilter) {
      return chartData
    }

    setIsLoading(true)
    const date_end = utilData(monthFilter)
    const response = await getApprovalsPending(
      organization_id,
      monthFilter,
      date_end
    )

    setIsLoading(false)
    if (response.status !== 200) {
      return updateChatData('', 0)
    }

    return updateChatData(
      response.data.data[0].data,
      response.data.data[0].name
    )
  }

  return <Chart updateChart={updateChart} isLoading={isLoading} />
}
